import React from 'react';
import { reduxForm } from 'redux-form';

import injectSheet from 'lib/sheet';
import ValuesList, { sheet } from 'components/ValuesList';
import { addLotAction } from 'domain/artwork';
import columns from 'fields/lot';
import { createFormConfig, submit } from 'lib/helpers';

const formFields = columns.select(
  'defaultArtImage',
  'condition',
  'auctionId',
  'auctionDate',
  'auctionTitle',
  'auctionLocation',
  'auctionSaleUrl',
  'auctionSaleDate',
  'auctionSaleTime',
  'saleNumber',
  'lotNumber',
  'lotUrls',
  'currency',
  'estimatePrice',
  'soldPrice',
  'sellerInfo',
  'saleType',
  'saleOutcome',
  'eveningSale',
);

const StyledValuesList = injectSheet({
  ...sheet,
  ValuesList: { marginRight: 150, width: 440 },
  value: { width: 300, display: 'flex' },
})(ValuesList);

class AddLotForm extends React.PureComponent {
  render(){
    return (
      <form>
        <StyledValuesList showStars config={createFormConfig(formFields)} rowData={{}} />
      </form>
    );
  }
}

export default reduxForm({
  form: 'addLotForm',
  onSubmit: submit(addLotAction),
})(AddLotForm);
